<template>
  <div class="dashboard">
    <div
      class="dashboard__sidebar"
      :class="toggleSideBar ? 'show-side-bar' : ''"
    >
      <div class="dashboard__sidebar__top dashboard__sidebar__center">
        <p
          class="
            dashboard__sidebar__top__header
            d-none
            business
            d-lg-block
            small-svg
          "
          @click="() => (toggleSideBar = !toggleSideBar)"
          style="height: 50px; font-size: 18px"
        >
          <Logo style="height: 30px" />
          {{ businessName }}
        </p>

        <p><br /></p>
        <p
          v-if="!toggleSideBar"
          class="dashboard__sidebar__top__header d-block d-lg-none"
          @click="() => (toggleSideBar = !toggleSideBar)"
        >
          <svg
            width="20"
            height="40"
            viewBox="0 0 20 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2 20.1158H18"
              stroke="#919EAB"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2 15.1047H18"
              stroke="#919EAB"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2 25.127H18"
              stroke="#919EAB"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </p>
        <router-link
          class="dashboard__sidebar__item"
          tag="div"
          to="/dashboard/overview"
        >
          <div
            class="dashboard__sidebar__item__icon"
            title="Dashboard"
            v-b-tooltip.hover.top
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 7.6L10 2L17 7.6V16.4C17 16.8243 16.8361 17.2313 16.5444 17.5314C16.2527 17.8314 15.857 18 15.4444 18H4.55556C4.143 18 3.74733 17.8314 3.45561 17.5314C3.16389 17.2313 3 16.8243 3 16.4V7.6Z"
                stroke="#919EAB"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <circle cx="10" cy="11" r="2.5" stroke="#919EAB" />
            </svg>
          </div>
          <div class="dashboard__sidebar__item__text d-none d-lg-block">
            Dashboard
          </div>
        </router-link>
        <div class="dashboard__sidebar__top__section d-none d-lg-block">
          PAYMENTS
        </div>

        <router-link
          class="dashboard__sidebar__item"
          tag="div"
          to="/dashboard/transactions?page=1"
        >
          <div
            class="dashboard__sidebar__item__icon"
            title="Transactions"
            v-b-tooltip.hover.top
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.20001 16V4"
                stroke="#919EAB"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M2 7.42857L5.2 4L8.4 7.42857"
                stroke="#919EAB"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14.8 4V16"
                stroke="#919EAB"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12 13L15.2 16.4286L18.4 13"
                stroke="#919EAB"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="dashboard__sidebar__item__text d-none d-lg-block">
            Transactions
          </div>
        </router-link>

        <router-link
          class="dashboard__sidebar__item"
          tag="div"
          to="/dashboard/mandates?page=1"
        >
          <div
            class="dashboard__sidebar__item__icon"
            title="DD Mandates"
            v-b-tooltip.hover.top
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.6667 2L13.3334 6.66667L14.8307 5.41797C15.965 6.6123 16.6667 8.21872 16.6667 10C16.6667 13.6897 13.6897 16.6667 10 16.6667C6.31036 16.6667 3.33339 13.6897 3.33339 10C3.33464 9.91166 3.31832 9.82395 3.28538 9.74197C3.25244 9.65999 3.20353 9.58538 3.1415 9.52246C3.07947 9.45955 3.00556 9.4096 2.92405 9.3755C2.84255 9.3414 2.75508 9.32384 2.66673 9.32384C2.57838 9.32384 2.49091 9.3414 2.40941 9.3755C2.3279 9.4096 2.25399 9.45955 2.19196 9.52246C2.12993 9.58538 2.08102 9.65999 2.04808 9.74197C2.01514 9.82395 1.99882 9.91166 2.00007 10C2.00007 14.4103 5.58974 18 10 18C14.4103 18 18 14.4103 18 10C18 7.90156 17.181 5.99355 15.8555 4.5651L17.3333 3.33333L12.6667 2ZM9.15108 2.04557L9.08598 2.05469L8.59639 2.39844L8.57947 2.99609L9.04821 3.36719L9.28259 3.3737L9.349 3.36458L9.83727 3.02083L9.8542 2.42318L9.38675 2.05208L9.15108 2.04557ZM6.5352 2.82031L6.31385 2.89974L6.25656 2.93229L5.92453 3.42969L6.12505 3.99219L6.69536 4.16927L6.91671 4.09115L6.97531 4.05729L7.30603 3.5599L7.10551 2.9974L6.5352 2.82031ZM4.76568 4.53906L4.16933 4.57422L3.98964 4.72656L3.94798 4.77734L3.81256 5.35937L4.19797 5.81641L4.79433 5.77995L4.97401 5.62891L5.01568 5.57812L5.1511 4.99609L4.76568 4.53906ZM3.14329 6.82161L2.59772 7.06641L2.48444 7.27214L2.4623 7.33464L2.54303 7.92708L3.06517 8.21615L3.61074 7.97135L3.72402 7.76563L3.74615 7.70313L3.66542 7.11068L3.14329 6.82161Z"
                fill="#919EAB"
              />
            </svg>
          </div>
          <div class="dashboard__sidebar__item__text d-none d-lg-block">
            DD Mandates
          </div>
        </router-link>

        <router-link
          class="dashboard__sidebar__item"
          tag="div"
          to="/dashboard/customers?page=1"
        >
          <div
            class="dashboard__sidebar__item__icon"
            title="Customers"
            v-b-tooltip.hover.top
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="20" height="20" fill="#EBDEE0" fill-opacity="0.1" />
              <path
                d="M9.99993 4C8.65734 4 7.56516 5.25599 7.56516 6.80002C7.56516 8.34404 8.65731 9.60003 9.99993 9.60003C11.3426 9.60003 12.4347 8.34401 12.4347 6.80002C12.4347 5.25603 11.3426 4 9.99993 4ZM9.99993 8.8C9.04134 8.8 8.26082 7.9024 8.26082 6.80002C8.26082 5.69763 9.04134 4.80003 9.99993 4.80003C10.9585 4.80003 11.739 5.69763 11.739 6.80002C11.739 7.9024 10.9586 8.8 9.99993 8.8Z"
                fill="#919EAB"
              />
              <path
                d="M14.8695 7.20001C13.9109 7.20001 13.1304 8.09761 13.1304 9.20001C13.1304 10.3024 13.9109 11.2 14.8695 11.2C15.8281 11.2 16.6086 10.3024 16.6086 9.20001C16.6086 8.09761 15.8281 7.20001 14.8695 7.20001ZM14.8695 10.4C14.2942 10.4 13.826 9.86162 13.826 9.20001C13.826 8.53839 14.2942 8 14.8695 8C15.4448 8 15.913 8.53839 15.913 9.20001C15.913 9.86162 15.4448 10.4 14.8695 10.4Z"
                fill="#919EAB"
              />
              <path
                d="M5.17981 7.20001C4.2205 7.20001 3.4407 8.09761 3.4407 9.20001C3.4407 10.3024 4.22122 11.2 5.17981 11.2C6.1384 11.2 6.91892 10.3024 6.91892 9.20001C6.91892 8.09761 6.13909 7.20001 5.17981 7.20001ZM5.17981 10.4C4.6045 10.4 4.13634 9.86162 4.13634 9.20001C4.13634 8.53839 4.6045 8 5.17981 8C5.75512 8 6.22328 8.53839 6.22328 9.20001C6.22328 9.86162 5.75509 10.4 5.17981 10.4Z"
                fill="#919EAB"
              />
              <path
                d="M9.99993 10.4C7.50672 10.4 5.47821 12.7328 5.47821 15.6C5.47821 15.8208 5.63405 16 5.82605 16C6.01804 16 6.17388 15.8208 6.17388 15.6C6.17388 13.1736 7.89003 11.2 9.99993 11.2C12.1098 11.2 13.826 13.1736 13.826 15.6C13.826 15.8208 13.9818 16 14.1738 16C14.3658 16 14.5217 15.8208 14.5217 15.6C14.5217 12.7328 12.4931 10.4 9.99993 10.4Z"
                fill="#919EAB"
              />
              <path
                d="M14.8695 12C14.297 12 13.7363 12.18 13.248 12.52C13.0845 12.6352 13.0316 12.8808 13.1311 13.0696C13.232 13.2584 13.4448 13.3184 13.609 13.204C13.9881 12.9392 14.4236 12.8 14.8695 12.8C16.2121 12.8 17.3043 14.056 17.3043 15.6C17.3043 15.8208 17.4602 16 17.6522 16C17.8442 16 18 15.8208 18 15.6C18 13.6152 16.5954 12 14.8695 12Z"
                fill="#919EAB"
              />
              <path
                d="M6.75129 12.5192C6.26363 12.18 5.70296 12 5.13042 12C3.40451 12 2 13.6152 2 15.6C2 15.8208 2.15584 16 2.34783 16C2.53983 16 2.69567 15.8208 2.69567 15.6C2.69564 14.056 3.78783 12.8 5.13042 12.8C5.57634 12.8 6.01179 12.9392 6.39024 13.2032C6.55371 13.3176 6.76798 13.2576 6.86816 13.0688C6.96833 12.88 6.91544 12.6344 6.75129 12.5192Z"
                fill="#919EAB"
              />
            </svg>
          </div>
          <div class="dashboard__sidebar__item__text d-none d-lg-block">
            Customers
          </div>
        </router-link>

        <router-link
          class="dashboard__sidebar__item"
          tag="div"
          to="/dashboard/payouts"
        >
          <div
            class="dashboard__sidebar__item__icon"
            title="Payouts"
            v-b-tooltip.hover.top
          >
            <svg
              width="18"
              height="14"
              viewBox="0 0 18 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.5455 1C16.3488 1 17 1.67157 17 2.5V11.5C17 12.3284 16.3488 13 15.5455 13"
                stroke="#919EAB"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1 5H17"
                stroke="#919EAB"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1 8H17"
                stroke="#919EAB"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="dashboard__sidebar__item__text d-none d-lg-block">
            Payouts
          </div>
        </router-link>
        <router-link
          class="dashboard__sidebar__item"
          tag="div"
          to="/dashboard/merchants?page=1"
        >
          <div
            class="dashboard__sidebar__item__icon"
            title="Merchants"
            v-b-tooltip.hover.top
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.77009 4.27565C7.77009 4.10399 7.91133 3.96487 8.08561 3.96487C8.25989 3.96487 8.40112 4.10399 8.40112 4.27565C8.40112 4.44731 8.2598 4.58642 8.08561 4.58642C7.91133 4.58642 7.77009 4.44731 7.77009 4.27565ZM5.99884 3.96487C5.82456 3.96487 5.68332 4.10399 5.68332 4.27565C5.68332 4.44731 5.82456 4.58642 5.99884 4.58642C6.17311 4.58642 6.31435 4.44731 6.31435 4.27565C6.31435 4.10399 6.17311 3.96487 5.99884 3.96487ZM8.91645 16.7862C8.95269 16.898 8.89014 17.0175 8.7766 17.0532C8.23694 17.223 7.66018 17.31 7.06211 17.3119C7.0609 17.3119 7.05969 17.312 7.05848 17.312C7.05762 17.312 7.05685 17.3119 7.05598 17.3119C7.05141 17.3119 7.04675 17.312 7.04218 17.312C5.90911 17.312 4.84238 17.0006 4.06037 16.4495C3.88963 16.8153 3.51407 17.07 3.07923 17.07C2.48418 17.07 2 16.5932 2 16.007V9.56923C2 8.73116 2.6922 8.04936 3.54306 8.04936H5.40784V7.54688C5.40784 7.5343 5.40905 7.52198 5.41112 7.50999C5.40353 7.46784 5.40879 7.42306 5.42898 7.3815C5.48049 7.27562 5.6093 7.231 5.71671 7.28174L7.04218 7.90728L8.36773 7.28174C8.47515 7.23092 8.60387 7.2757 8.65538 7.3815C8.67557 7.42306 8.68083 7.46784 8.67324 7.50999C8.6754 7.52198 8.67652 7.5343 8.67652 7.54688V8.04936H10.5414C11.012 8.04936 11.451 8.25697 11.7456 8.6189C11.8202 8.71043 11.8053 8.8441 11.7123 8.91752C11.6725 8.94896 11.6248 8.96426 11.5775 8.96426C11.5143 8.96426 11.4517 8.93707 11.4091 8.88472C11.1967 8.62392 10.8805 8.47427 10.5413 8.47427H10.0423L9.46051 10.5065C9.44326 10.5666 9.40012 10.6162 9.3424 10.6421L8.88013 10.8498L9.15285 11.0718C9.24266 11.1449 9.25733 11.2751 9.18581 11.3658L7.274 13.7913V16.8824C7.75154 16.8633 8.21174 16.7848 8.6452 16.6484C8.75882 16.6125 8.88022 16.6744 8.91645 16.7862ZM5.77719 10.961L5.40008 11.268L6.84279 13.0984V12.9379L5.46366 8.47418H4.52281L5.04444 10.2963L5.72931 10.604C5.79695 10.6344 5.84388 10.6969 5.85363 10.7695C5.86338 10.842 5.83448 10.9144 5.77719 10.961ZM9.59424 8.47418H8.6219L7.27426 12.9373V13.0984L8.71698 11.268L8.33987 10.961C8.28258 10.9144 8.25367 10.842 8.26342 10.7694C8.27317 10.6968 8.32011 10.6344 8.38775 10.604L9.07261 10.2962L9.59424 8.47418ZM6.949 8.33439L5.83922 7.81066V8.2302L7.05616 12.169L8.24522 8.23097V7.81074L7.13536 8.33456C7.10594 8.34849 7.07401 8.35546 7.04218 8.35546C7.01034 8.35521 6.97851 8.34824 6.949 8.33439ZM2.43138 9.56915V14.4982H3.72709V11.3017C3.72709 11.1844 3.82363 11.0893 3.94278 11.0893C4.06193 11.0893 4.15847 11.1844 4.15847 11.3017V15.9895C4.83332 16.5269 5.79712 16.8474 6.84288 16.8836V13.7913L4.93108 11.3658C4.85955 11.2751 4.87422 11.1449 4.96403 11.0718L5.23675 10.8498L4.77448 10.6421C4.71685 10.6162 4.67363 10.5666 4.65637 10.5065L4.07461 8.47427H3.54297C2.93006 8.47418 2.43138 8.96537 2.43138 9.56915ZM3.72709 16.0069V14.9231H2.43138V16.0069C2.43138 16.3587 2.72205 16.645 3.07923 16.645C3.43642 16.645 3.72709 16.3587 3.72709 16.0069ZM7.42818 5.48781C7.21542 5.69728 6.86911 5.69737 6.65626 5.48781C6.57206 5.40478 6.4354 5.40478 6.35128 5.48781C6.26698 5.57075 6.26698 5.70527 6.35128 5.78821C6.54177 5.97585 6.79198 6.06966 7.04226 6.06966C7.29247 6.06966 7.54267 5.97585 7.73317 5.78821C7.81737 5.70527 7.81737 5.57075 7.73317 5.48781C7.64905 5.40478 7.51239 5.40478 7.42818 5.48781ZM18 12.7703C18 13.0573 17.7629 13.2909 17.4715 13.2909H9.41427C9.12283 13.2909 8.88574 13.0573 8.88574 12.7703C8.88574 12.4833 9.12283 12.2497 9.41427 12.2497H9.51288L13.1626 8.55355C13.2368 8.47834 13.3364 8.43696 13.443 8.43696C13.5495 8.43696 13.649 8.47834 13.7233 8.55355L17.373 12.2497H17.4716C17.7629 12.2497 18 12.4832 18 12.7703ZM17.5686 12.7703C17.5686 12.7175 17.525 12.6746 17.4715 12.6746H17.2817C17.2235 12.6746 17.1678 12.6514 17.1271 12.6103L13.4429 8.87911L9.7586 12.6103C9.71796 12.6514 9.66223 12.6746 9.60399 12.6746H9.41427C9.36069 12.6746 9.31712 12.7175 9.31712 12.7703C9.31712 12.823 9.36069 12.866 9.41427 12.866H17.4715C17.525 12.866 17.5686 12.823 17.5686 12.7703ZM17.4974 18.1256V18.7875C17.4974 18.9049 17.4009 19 17.2817 19H9.60399C9.48484 19 9.3883 18.9049 9.3883 18.7875V18.1256C9.3883 17.8657 9.60304 17.6543 9.86688 17.6543H17.0188C17.2827 17.6543 17.4974 17.8657 17.4974 18.1256ZM17.0661 18.1256C17.0661 18.1 17.0448 18.0792 17.0189 18.0792H9.86696C9.84091 18.0792 9.81977 18.1001 9.81977 18.1256V18.5751H17.0661V18.1256H17.0661ZM9.9912 17.0064V13.9914C9.88051 13.9233 9.80674 13.8023 9.80674 13.6645C9.80674 13.5472 9.90328 13.4521 10.0224 13.4521C10.1278 13.4521 10.2154 13.5264 10.2343 13.6247H11.3889C11.4078 13.5264 11.4954 13.4521 11.6008 13.4521C11.7199 13.4521 11.8165 13.5472 11.8165 13.6645C11.8165 13.8023 11.7427 13.9233 11.632 13.9914V17.0064C11.7427 17.0745 11.8165 17.1956 11.8165 17.3333C11.8165 17.4506 11.7199 17.5457 11.6008 17.5457C11.4954 17.5457 11.4078 17.4714 11.3889 17.3731H10.2343C10.2154 17.4714 10.1278 17.5457 10.0224 17.5457C9.90328 17.5457 9.80674 17.4506 9.80674 17.3333C9.80683 17.1955 9.88059 17.0745 9.9912 17.0064ZM10.4226 14.0496V16.9482H11.2007V14.0496H10.4226ZM15.2536 17.0064V13.9914C15.143 13.9234 15.0692 13.8023 15.0692 13.6645C15.0692 13.5472 15.1657 13.4521 15.2849 13.4521C15.3902 13.4521 15.4779 13.5264 15.4968 13.6247H16.6514C16.6703 13.5264 16.758 13.4521 16.8633 13.4521C16.9825 13.4521 17.079 13.5472 17.079 13.6645C17.079 13.8023 17.0052 13.9233 16.8945 13.9914V17.0064C17.0052 17.0745 17.079 17.1956 17.079 17.3333C17.079 17.4506 16.9825 17.5457 16.8633 17.5457C16.758 17.5457 16.6703 17.4714 16.6514 17.3731H15.4968C15.4779 17.4714 15.3902 17.5457 15.2849 17.5457C15.1657 17.5457 15.0692 17.4506 15.0692 17.3333C15.0691 17.1955 15.143 17.0745 15.2536 17.0064ZM15.685 14.0496V16.9482H16.4632V14.0496H15.685ZM12.6225 17.0064V13.9914C12.5118 13.9233 12.438 13.8023 12.438 13.6645C12.438 13.5472 12.5345 13.4521 12.6537 13.4521C12.759 13.4521 12.8467 13.5264 12.8656 13.6247H14.0201C14.039 13.5264 14.1267 13.4521 14.232 13.4521C14.3512 13.4521 14.4477 13.5472 14.4477 13.6645C14.4477 13.8023 14.374 13.9233 14.2633 13.9914V17.0064C14.374 17.0745 14.4477 17.1956 14.4477 17.3333C14.4477 17.4506 14.3512 17.5457 14.232 17.5457C14.1267 17.5457 14.039 17.4714 14.0201 17.3731H12.8656C12.8467 17.4714 12.759 17.5457 12.6537 17.5457C12.5345 17.5457 12.438 17.4506 12.438 17.3333C12.438 17.1955 12.5118 17.0745 12.6225 17.0064ZM13.0538 14.0496V16.9482H13.832V14.0496H13.0538ZM4.2073 3.7226C4.2073 2.22134 5.47902 1 7.04226 1C8.60542 1 9.87714 2.22134 9.87714 3.7226C9.87714 3.825 9.80303 3.91278 9.70079 3.93148C9.47009 3.97363 9.2311 3.99377 8.9897 3.99377C7.87475 3.99377 6.70492 3.56462 6.02299 2.89106C5.69963 3.61119 5.06213 3.82415 4.46156 3.93165C4.39866 3.94287 4.33387 3.92604 4.28478 3.88567C4.23569 3.84531 4.2073 3.78557 4.2073 3.7226ZM4.65482 3.45533C5.28843 3.29209 5.58919 2.99321 5.73026 2.41773C5.7501 2.33674 5.8161 2.2747 5.89919 2.2589C5.91282 2.25635 5.92645 2.25507 5.93999 2.25507C6.00902 2.25507 6.07493 2.28779 6.11583 2.34456C6.71088 3.17022 8.19587 3.6954 9.43843 3.54167C9.34162 2.359 8.30397 1.4249 7.04226 1.4249C5.81144 1.4249 4.79381 2.31388 4.65482 3.45533ZM4.68139 4.4926C4.66241 4.37677 4.55154 4.29817 4.43404 4.31669C4.31644 4.33539 4.23646 4.4445 4.25544 4.56033C4.50513 6.08454 5.67711 7.19081 7.04218 7.19081C8.40725 7.19081 9.57923 6.08454 9.82891 4.56033C9.8479 4.4445 9.76792 4.33547 9.65032 4.31669C9.53238 4.29825 9.42195 4.37677 9.40297 4.4926C9.18719 5.8098 8.19432 6.76591 7.04209 6.76591C5.88987 6.76591 4.89717 5.80988 4.68139 4.4926Z"
                fill="#919EAB"
              />
            </svg>
          </div>
          <div class="dashboard__sidebar__item__text d-none d-lg-block">
            Merchants
          </div>
        </router-link>

        <router-link
          class="dashboard__sidebar__item"
          tag="div"
          to="/dashboard/banks?page=1"
        >
          <div
            class="dashboard__sidebar__item__icon"
            title="Banks"
            v-b-tooltip.hover.top
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.4406 5.03101C13.57 5.03101 13.6749 4.91998 13.6749 4.78296C13.6749 4.64594 13.57 4.53491 13.4406 4.53491H10.7092C10.5797 4.53491 10.4748 4.64594 10.4748 4.78296C10.4748 4.91998 10.5797 5.03101 10.7092 5.03101H13.4406Z"
                fill="#919EAB"
              />
              <path
                d="M9.53729 5.99353C9.53729 6.13055 9.64223 6.24158 9.77167 6.24158H13.4406C13.57 6.24158 13.6749 6.13055 13.6749 5.99353C13.6749 5.85651 13.57 5.74548 13.4406 5.74548H9.77167C9.64223 5.74548 9.53729 5.85651 9.53729 5.99353Z"
                fill="#919EAB"
              />
              <path
                d="M9.77167 7.45191H13.4406C13.57 7.45191 13.6749 7.34088 13.6749 7.20386C13.6749 7.06684 13.57 6.95581 13.4406 6.95581H9.77167C9.64223 6.95581 9.53729 7.06684 9.53729 7.20386C9.53729 7.34088 9.64223 7.45191 9.77167 7.45191Z"
                fill="#919EAB"
              />
              <path
                d="M6.19479 12.2538C5.97082 12.2538 5.78864 12.4466 5.78864 12.6836V15.0537C5.78864 15.2907 5.97082 15.4835 6.19479 15.4835H7.65585C7.87979 15.4835 8.06198 15.2907 8.06198 15.0537V12.6836C8.06198 12.4466 7.87979 12.2538 7.65585 12.2538H6.19479ZM7.59326 14.9874H6.25742V12.7499H7.59326V14.9874Z"
                fill="#919EAB"
              />
              <path
                d="M8.86328 12.0221V15.0536C8.86328 15.2906 9.04547 15.4835 9.26941 15.4835H10.7305C10.9544 15.4835 11.1366 15.2906 11.1366 15.0536V12.0221C11.1366 11.7851 10.9544 11.5923 10.7305 11.5923H9.26941C9.0455 11.5923 8.86328 11.7851 8.86328 12.0221ZM9.33203 12.0884H10.6679V14.9874H9.33203V12.0884Z"
                fill="#919EAB"
              />
              <path
                d="M17.4775 11.6841C17.492 11.6283 17.5004 11.5697 17.5004 11.5091V11.0362C17.5004 10.7307 17.3034 10.4737 17.037 10.398C17.0538 10.3382 17.0632 10.275 17.0632 10.2095V9.73656C17.0632 9.67104 17.0538 9.60783 17.037 9.54804C17.3034 9.47237 17.5004 9.21529 17.5004 8.90979V8.43694C17.5004 8.07224 17.22 7.77551 16.8754 7.77551H15.4314V3.51541C15.4314 3.23121 15.2129 3 14.9444 3H8.42741C8.29797 3 8.19303 3.11103 8.19303 3.24805C8.19303 3.38507 8.29797 3.4961 8.42741 3.4961H14.9444C14.9544 3.4961 14.9627 3.50476 14.9627 3.51541V16.4846C14.9627 16.4952 14.9544 16.5039 14.9444 16.5039H5.05562C5.04556 16.5039 5.03737 16.4952 5.03737 16.4846C5.03737 15.0722 5.03737 4.98377 5.03737 3.51541C5.03737 3.50476 5.04556 3.4961 5.05562 3.4961H7.49031C7.61975 3.4961 7.72469 3.38507 7.72469 3.24805C7.72469 3.11103 7.61975 3 7.49031 3H5.05562C4.78709 3 4.56862 3.23121 4.56862 3.51541V9.07516H3.12459C2.78 9.07516 2.49962 9.37189 2.49962 9.73659V10.2095C2.49962 10.2702 2.50803 10.3287 2.52253 10.3845C2.22659 10.4364 2 10.7085 2 11.0362V11.5091C2 11.8368 2.22659 12.1089 2.52253 12.1609C2.508 12.2167 2.49962 12.2752 2.49962 12.3359V12.8088C2.49962 12.8694 2.50803 12.9279 2.52253 12.9838C2.22659 13.0357 2 13.3077 2 13.6355V14.1084C2 14.2647 2.05181 14.4084 2.13784 14.5218C2.05181 14.6351 2 14.7787 2 14.9351V15.408C2 15.7727 2.28034 16.0695 2.62497 16.0695H2.99963C3.12906 16.0695 3.234 15.9584 3.234 15.8214C3.234 15.6844 3.12906 15.5734 2.99963 15.5734H2.62497C2.53884 15.5734 2.46875 15.4992 2.46875 15.408V14.9351C2.46875 14.8439 2.53881 14.7698 2.62497 14.7698H4.56862V15.5734H3.93675C3.80731 15.5734 3.70238 15.6844 3.70238 15.8214C3.70238 15.9584 3.80731 16.0695 3.93675 16.0695H4.56862V16.4846C4.56862 16.7688 4.78709 17 5.05562 17H14.9444C15.2129 17 15.4314 16.7688 15.4314 16.4846V16.0695H16.8754C17.22 16.0695 17.5004 15.7727 17.5004 15.408V14.9351C17.5004 14.7787 17.4486 14.6351 17.3625 14.5217C17.4486 14.4084 17.5004 14.2647 17.5004 14.1083V13.6354C17.5004 13.5748 17.492 13.5163 17.4775 13.4604C17.7734 13.4084 18 13.1364 18 12.8087V12.3358C18 12.0082 17.7734 11.7361 17.4775 11.6841ZM2.96838 12.8087V12.3358C2.96838 12.2447 3.03847 12.1705 3.12459 12.1705H4.56859V12.9741H3.12459C3.03844 12.9741 2.96838 12.8999 2.96838 12.8087ZM2.96838 9.73656C2.96838 9.64537 3.03847 9.57122 3.12459 9.57122H4.56859V10.3748H3.12459C3.03847 10.3748 2.96838 10.3006 2.96838 10.2095V9.73656ZM2.46875 11.5091V11.0362C2.46875 10.945 2.53881 10.8709 2.62497 10.8709H3.12459H4.56859V11.6744C4.10041 11.6744 3.08759 11.6744 2.62494 11.6744C2.53881 11.6744 2.46875 11.6003 2.46875 11.5091ZM2.62497 14.2737C2.53884 14.2737 2.46875 14.1995 2.46875 14.1084V13.6355C2.46875 13.5443 2.53881 13.4702 2.62497 13.4702H4.56862V14.2737H2.62497ZM17.0316 13.6355V14.1084C17.0316 14.1995 16.9616 14.2737 16.8754 14.2737H15.4314V13.4702H16.8754C16.9616 13.4702 17.0316 13.5443 17.0316 13.6355ZM16.5945 9.73656V10.2095C16.5945 10.3006 16.5244 10.3748 16.4382 10.3748H15.4314V9.57126H16.4382C16.5244 9.57126 16.5945 9.64544 16.5945 9.73656ZM15.4314 10.8709H16.8754C16.9616 10.8709 17.0316 10.945 17.0316 11.0362V11.5091C17.0316 11.6003 16.9616 11.6744 16.8754 11.6744H15.4314V10.8709ZM16.8754 8.27158C16.9616 8.27158 17.0316 8.34573 17.0316 8.43691V8.90979C17.0316 9.00097 16.9616 9.07516 16.8754 9.07516C16.6331 9.07516 15.8029 9.07516 15.4314 9.07516V8.27158H16.8754ZM17.0316 15.408C17.0316 15.4992 16.9616 15.5734 16.8754 15.5734H15.4314V14.7698H16.8754C16.9616 14.7698 17.0316 14.8439 17.0316 14.9351V15.408ZM17.5312 12.8087C17.5312 12.8999 17.4612 12.9741 17.375 12.9741C16.9143 12.9741 15.9005 12.9741 15.4314 12.9741V12.1705H17.375C17.4612 12.1705 17.5312 12.2447 17.5312 12.3358V12.8087Z"
                fill="#919EAB"
              />
              <path
                d="M13.977 13.29C14.1065 13.29 14.2114 13.1789 14.2114 13.0419V10.6991C14.2114 10.4621 14.0292 10.2693 13.8053 10.2693H12.3442C12.1202 10.2693 11.938 10.4621 11.938 10.6991V15.0536C11.938 15.2906 12.1202 15.4834 12.3442 15.4834H13.8053C14.0292 15.4834 14.2114 15.2906 14.2114 15.0536V14.0337C14.2114 13.8967 14.1065 13.7856 13.977 13.7856C13.8475 13.7856 13.7426 13.8967 13.7426 14.0337V14.9873H12.4068V10.7654H13.7426V13.0419C13.7426 13.1789 13.8476 13.29 13.977 13.29Z"
                fill="#919EAB"
              />
            </svg>
          </div>
          <div class="dashboard__sidebar__item__text d-none d-lg-block">
            Banks
          </div>
        </router-link>
        <router-link
          class="dashboard__sidebar__item"
          tag="div"
          to="/dashboard/transfers?page=1&request_status=APPROVED"
        >
          <div
            class="dashboard__sidebar__item__icon"
            title="Transfers"
            v-b-tooltip.hover.top
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.4406 5.03101C13.57 5.03101 13.6749 4.91998 13.6749 4.78296C13.6749 4.64594 13.57 4.53491 13.4406 4.53491H10.7092C10.5797 4.53491 10.4748 4.64594 10.4748 4.78296C10.4748 4.91998 10.5797 5.03101 10.7092 5.03101H13.4406Z"
                fill="#919EAB"
              />
              <path
                d="M9.53729 5.99353C9.53729 6.13055 9.64223 6.24158 9.77167 6.24158H13.4406C13.57 6.24158 13.6749 6.13055 13.6749 5.99353C13.6749 5.85651 13.57 5.74548 13.4406 5.74548H9.77167C9.64223 5.74548 9.53729 5.85651 9.53729 5.99353Z"
                fill="#919EAB"
              />
              <path
                d="M9.77167 7.45191H13.4406C13.57 7.45191 13.6749 7.34088 13.6749 7.20386C13.6749 7.06684 13.57 6.95581 13.4406 6.95581H9.77167C9.64223 6.95581 9.53729 7.06684 9.53729 7.20386C9.53729 7.34088 9.64223 7.45191 9.77167 7.45191Z"
                fill="#919EAB"
              />
              <path
                d="M6.19479 12.2538C5.97082 12.2538 5.78864 12.4466 5.78864 12.6836V15.0537C5.78864 15.2907 5.97082 15.4835 6.19479 15.4835H7.65585C7.87979 15.4835 8.06198 15.2907 8.06198 15.0537V12.6836C8.06198 12.4466 7.87979 12.2538 7.65585 12.2538H6.19479ZM7.59326 14.9874H6.25742V12.7499H7.59326V14.9874Z"
                fill="#919EAB"
              />
              <path
                d="M8.86328 12.0221V15.0536C8.86328 15.2906 9.04547 15.4835 9.26941 15.4835H10.7305C10.9544 15.4835 11.1366 15.2906 11.1366 15.0536V12.0221C11.1366 11.7851 10.9544 11.5923 10.7305 11.5923H9.26941C9.0455 11.5923 8.86328 11.7851 8.86328 12.0221ZM9.33203 12.0884H10.6679V14.9874H9.33203V12.0884Z"
                fill="#919EAB"
              />
              <path
                d="M17.4775 11.6841C17.492 11.6283 17.5004 11.5697 17.5004 11.5091V11.0362C17.5004 10.7307 17.3034 10.4737 17.037 10.398C17.0538 10.3382 17.0632 10.275 17.0632 10.2095V9.73656C17.0632 9.67104 17.0538 9.60783 17.037 9.54804C17.3034 9.47237 17.5004 9.21529 17.5004 8.90979V8.43694C17.5004 8.07224 17.22 7.77551 16.8754 7.77551H15.4314V3.51541C15.4314 3.23121 15.2129 3 14.9444 3H8.42741C8.29797 3 8.19303 3.11103 8.19303 3.24805C8.19303 3.38507 8.29797 3.4961 8.42741 3.4961H14.9444C14.9544 3.4961 14.9627 3.50476 14.9627 3.51541V16.4846C14.9627 16.4952 14.9544 16.5039 14.9444 16.5039H5.05562C5.04556 16.5039 5.03737 16.4952 5.03737 16.4846C5.03737 15.0722 5.03737 4.98377 5.03737 3.51541C5.03737 3.50476 5.04556 3.4961 5.05562 3.4961H7.49031C7.61975 3.4961 7.72469 3.38507 7.72469 3.24805C7.72469 3.11103 7.61975 3 7.49031 3H5.05562C4.78709 3 4.56862 3.23121 4.56862 3.51541V9.07516H3.12459C2.78 9.07516 2.49962 9.37189 2.49962 9.73659V10.2095C2.49962 10.2702 2.50803 10.3287 2.52253 10.3845C2.22659 10.4364 2 10.7085 2 11.0362V11.5091C2 11.8368 2.22659 12.1089 2.52253 12.1609C2.508 12.2167 2.49962 12.2752 2.49962 12.3359V12.8088C2.49962 12.8694 2.50803 12.9279 2.52253 12.9838C2.22659 13.0357 2 13.3077 2 13.6355V14.1084C2 14.2647 2.05181 14.4084 2.13784 14.5218C2.05181 14.6351 2 14.7787 2 14.9351V15.408C2 15.7727 2.28034 16.0695 2.62497 16.0695H2.99963C3.12906 16.0695 3.234 15.9584 3.234 15.8214C3.234 15.6844 3.12906 15.5734 2.99963 15.5734H2.62497C2.53884 15.5734 2.46875 15.4992 2.46875 15.408V14.9351C2.46875 14.8439 2.53881 14.7698 2.62497 14.7698H4.56862V15.5734H3.93675C3.80731 15.5734 3.70238 15.6844 3.70238 15.8214C3.70238 15.9584 3.80731 16.0695 3.93675 16.0695H4.56862V16.4846C4.56862 16.7688 4.78709 17 5.05562 17H14.9444C15.2129 17 15.4314 16.7688 15.4314 16.4846V16.0695H16.8754C17.22 16.0695 17.5004 15.7727 17.5004 15.408V14.9351C17.5004 14.7787 17.4486 14.6351 17.3625 14.5217C17.4486 14.4084 17.5004 14.2647 17.5004 14.1083V13.6354C17.5004 13.5748 17.492 13.5163 17.4775 13.4604C17.7734 13.4084 18 13.1364 18 12.8087V12.3358C18 12.0082 17.7734 11.7361 17.4775 11.6841ZM2.96838 12.8087V12.3358C2.96838 12.2447 3.03847 12.1705 3.12459 12.1705H4.56859V12.9741H3.12459C3.03844 12.9741 2.96838 12.8999 2.96838 12.8087ZM2.96838 9.73656C2.96838 9.64537 3.03847 9.57122 3.12459 9.57122H4.56859V10.3748H3.12459C3.03847 10.3748 2.96838 10.3006 2.96838 10.2095V9.73656ZM2.46875 11.5091V11.0362C2.46875 10.945 2.53881 10.8709 2.62497 10.8709H3.12459H4.56859V11.6744C4.10041 11.6744 3.08759 11.6744 2.62494 11.6744C2.53881 11.6744 2.46875 11.6003 2.46875 11.5091ZM2.62497 14.2737C2.53884 14.2737 2.46875 14.1995 2.46875 14.1084V13.6355C2.46875 13.5443 2.53881 13.4702 2.62497 13.4702H4.56862V14.2737H2.62497ZM17.0316 13.6355V14.1084C17.0316 14.1995 16.9616 14.2737 16.8754 14.2737H15.4314V13.4702H16.8754C16.9616 13.4702 17.0316 13.5443 17.0316 13.6355ZM16.5945 9.73656V10.2095C16.5945 10.3006 16.5244 10.3748 16.4382 10.3748H15.4314V9.57126H16.4382C16.5244 9.57126 16.5945 9.64544 16.5945 9.73656ZM15.4314 10.8709H16.8754C16.9616 10.8709 17.0316 10.945 17.0316 11.0362V11.5091C17.0316 11.6003 16.9616 11.6744 16.8754 11.6744H15.4314V10.8709ZM16.8754 8.27158C16.9616 8.27158 17.0316 8.34573 17.0316 8.43691V8.90979C17.0316 9.00097 16.9616 9.07516 16.8754 9.07516C16.6331 9.07516 15.8029 9.07516 15.4314 9.07516V8.27158H16.8754ZM17.0316 15.408C17.0316 15.4992 16.9616 15.5734 16.8754 15.5734H15.4314V14.7698H16.8754C16.9616 14.7698 17.0316 14.8439 17.0316 14.9351V15.408ZM17.5312 12.8087C17.5312 12.8999 17.4612 12.9741 17.375 12.9741C16.9143 12.9741 15.9005 12.9741 15.4314 12.9741V12.1705H17.375C17.4612 12.1705 17.5312 12.2447 17.5312 12.3358V12.8087Z"
                fill="#919EAB"
              />
              <path
                d="M13.977 13.29C14.1065 13.29 14.2114 13.1789 14.2114 13.0419V10.6991C14.2114 10.4621 14.0292 10.2693 13.8053 10.2693H12.3442C12.1202 10.2693 11.938 10.4621 11.938 10.6991V15.0536C11.938 15.2906 12.1202 15.4834 12.3442 15.4834H13.8053C14.0292 15.4834 14.2114 15.2906 14.2114 15.0536V14.0337C14.2114 13.8967 14.1065 13.7856 13.977 13.7856C13.8475 13.7856 13.7426 13.8967 13.7426 14.0337V14.9873H12.4068V10.7654H13.7426V13.0419C13.7426 13.1789 13.8476 13.29 13.977 13.29Z"
                fill="#919EAB"
              />
            </svg>
          </div>
          <div class="dashboard__sidebar__item__text d-none d-lg-block">
            Transfers
          </div>
        </router-link>
        <router-link
          class="dashboard__sidebar__item"
          tag="div"
          to="/dashboard/settlements/processed"
        >
          <div
            class="dashboard__sidebar__item__icon"
            title="Settlements"
            v-b-tooltip.hover.top
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 12.4L10 18L17 12.4V3.6C17 3.17565 16.8361 2.76869 16.5444 2.46863C16.2527 2.16857 15.857 2 15.4444 2H4.55556C4.143 2 3.74733 2.16857 3.45561 2.46863C3.16389 2.76869 3 3.17565 3 3.6V12.4Z"
                stroke="#919EAB"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <circle
                r="2.5"
                transform="matrix(1 0 0 -1 10 9)"
                stroke="#919EAB"
              />
            </svg>
          </div>
          <div class="dashboard__sidebar__item__text d-none d-lg-block">
            Settlements
          </div>
        </router-link>
        <router-link
          class="dashboard__sidebar__item"
          tag="div"
          to="/dashboard/statements"
        >
          <div
            class="dashboard__sidebar__item__icon"
            title="Statements"
            v-b-tooltip.hover.top
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.40005 8.49411H4.90005V9.49411H5.40005V8.49411ZM12.6 9.49411H13.1V8.49411H12.6V9.49411ZM5.40059 12.0918L4.90059 12.0912L4.8995 13.0912L5.3995 13.0918L5.40059 12.0918ZM12.5995 13.0996L13.0995 13.1002L13.1006 12.1002L12.6006 12.0996L12.5995 13.0996ZM5.40038 4.89646L4.90038 4.89613L4.89972 5.89613L5.39972 5.89646L5.40038 4.89646ZM10.1997 5.89961L10.6997 5.89994L10.7004 4.89994L10.2004 4.89961L10.1997 5.89961ZM12.6 0.599609L12.9536 0.246056L12.8072 0.0996094H12.6V0.599609ZM16.2 4.19961H16.7V3.9925L16.5536 3.84606L16.2 4.19961ZM5.40005 9.49411H12.6V8.49411H5.40005V9.49411ZM5.3995 13.0918L12.5995 13.0996L12.6006 12.0996L5.40059 12.0918L5.3995 13.0918ZM5.39972 5.89646L10.1997 5.89961L10.2004 4.89961L5.40038 4.89646L5.39972 5.89646ZM15 16.8996H3.00005V17.8996H15V16.8996ZM2.30005 16.1996V1.79961H1.30005V16.1996H2.30005ZM3.00005 1.09961H12.6V0.0996094H3.00005V1.09961ZM15.7 4.19961V16.1996H16.7V4.19961H15.7ZM12.2465 0.953163L15.8465 4.55316L16.5536 3.84606L12.9536 0.246056L12.2465 0.953163ZM3.00005 16.8996C2.61345 16.8996 2.30005 16.5862 2.30005 16.1996H1.30005C1.30005 17.1385 2.06116 17.8996 3.00005 17.8996V16.8996ZM15 17.8996C15.9389 17.8996 16.7 17.1385 16.7 16.1996H15.7C15.7 16.5862 15.3866 16.8996 15 16.8996V17.8996ZM2.30005 1.79961C2.30005 1.41301 2.61345 1.09961 3.00005 1.09961V0.0996094C2.06116 0.0996094 1.30005 0.860726 1.30005 1.79961H2.30005Z"
                fill="#919EAB"
              />
            </svg>
          </div>
          <div class="dashboard__sidebar__item__text d-none d-lg-block">
            Statements
          </div>
        </router-link>
        <router-link
          class="dashboard__sidebar__item"
          tag="div"
          to="/dashboard/bills-payment"
        >
          <div
            class="dashboard__sidebar__item__icon"
            title="Bills Payment"
            v-b-tooltip.hover.top
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
            <path
                  d="M8.7513 6.6665C7.37059 6.6665 6.2513 7.7858 6.2513 9.1665C6.2513 10.5473 7.37059 11.6665 8.7513 11.6665C10.1321 11.6665 11.2513 10.5473 11.2513 9.1665C11.2513 7.7858 10.1321 6.6665 8.7513 6.6665ZM7.5013 9.1665C7.5013 8.47617 8.06094 7.9165 8.7513 7.9165C9.44164 7.9165 10.0013 8.47617 10.0013 9.1665C10.0013 9.85684 9.44164 10.4165 8.7513 10.4165C8.06094 10.4165 7.5013 9.85684 7.5013 9.1665ZM1.66797 6.0415C1.66797 5.00597 2.50744 4.1665 3.54297 4.1665H13.9596C14.9951 4.1665 15.8346 5.00597 15.8346 6.0415V12.2915C15.8346 13.327 14.9951 14.1665 13.9596 14.1665H3.54297C2.50744 14.1665 1.66797 13.327 1.66797 12.2915V6.0415ZM3.54297 5.4165C3.19779 5.4165 2.91797 5.69633 2.91797 6.0415V6.6665H3.54297C3.88814 6.6665 4.16797 6.38668 4.16797 6.0415V5.4165H3.54297ZM2.91797 10.4165H3.54297C4.5785 10.4165 5.41797 11.256 5.41797 12.2915V12.9165H12.0846V12.2915C12.0846 11.256 12.9241 10.4165 13.9596 10.4165H14.5846V7.9165H13.9596C12.9241 7.9165 12.0846 7.07704 12.0846 6.0415V5.4165H5.41797V6.0415C5.41797 7.07704 4.5785 7.9165 3.54297 7.9165H2.91797V10.4165ZM14.5846 6.6665V6.0415C14.5846 5.69633 14.3048 5.4165 13.9596 5.4165H13.3346V6.0415C13.3346 6.38668 13.6145 6.6665 13.9596 6.6665H14.5846ZM14.5846 11.6665H13.9596C13.6145 11.6665 13.3346 11.9463 13.3346 12.2915V12.9165H13.9596C14.3048 12.9165 14.5846 12.6367 14.5846 12.2915V11.6665ZM2.91797 12.2915C2.91797 12.6367 3.19779 12.9165 3.54297 12.9165H4.16797V12.2915C4.16797 11.9463 3.88814 11.6665 3.54297 11.6665H2.91797V12.2915ZM3.66911 15.4165C4.10137 16.1638 4.9093 16.6665 5.83465 16.6665H14.3763C16.5625 16.6665 18.3346 14.8943 18.3346 12.7082V8.33317C18.3346 7.40784 17.8319 6.5999 17.0846 6.16765V12.7082C17.0846 14.2039 15.8721 15.4165 14.3763 15.4165H3.66911Z"
                  fill="#919EAB"
                />
            </svg>
          </div>
          <div class="dashboard__sidebar__item__text d-none d-lg-block">
            Bills Payment
          </div>
        </router-link>
        <div class="dashboard__sidebar__top__section d-none d-lg-block">
          SECURITY
        </div>
        <router-link
          class="dashboard__sidebar__item"
          tag="div"
          to="/dashboard/lien"
        >
          <div
            class="dashboard__sidebar__item__icon"
            title="Active Liens"
            v-b-tooltip.hover.top
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.6667 2L13.3334 6.66667L14.8307 5.41797C15.965 6.6123 16.6667 8.21872 16.6667 10C16.6667 13.6897 13.6897 16.6667 10 16.6667C6.31036 16.6667 3.33339 13.6897 3.33339 10C3.33464 9.91166 3.31832 9.82395 3.28538 9.74197C3.25244 9.65999 3.20353 9.58538 3.1415 9.52246C3.07947 9.45955 3.00556 9.4096 2.92405 9.3755C2.84255 9.3414 2.75508 9.32384 2.66673 9.32384C2.57838 9.32384 2.49091 9.3414 2.40941 9.3755C2.3279 9.4096 2.25399 9.45955 2.19196 9.52246C2.12993 9.58538 2.08102 9.65999 2.04808 9.74197C2.01514 9.82395 1.99882 9.91166 2.00007 10C2.00007 14.4103 5.58974 18 10 18C14.4103 18 18 14.4103 18 10C18 7.90156 17.181 5.99355 15.8555 4.5651L17.3333 3.33333L12.6667 2ZM9.15108 2.04557L9.08598 2.05469L8.59639 2.39844L8.57947 2.99609L9.04821 3.36719L9.28259 3.3737L9.349 3.36458L9.83727 3.02083L9.8542 2.42318L9.38675 2.05208L9.15108 2.04557ZM6.5352 2.82031L6.31385 2.89974L6.25656 2.93229L5.92453 3.42969L6.12505 3.99219L6.69536 4.16927L6.91671 4.09115L6.97531 4.05729L7.30603 3.5599L7.10551 2.9974L6.5352 2.82031ZM4.76568 4.53906L4.16933 4.57422L3.98964 4.72656L3.94798 4.77734L3.81256 5.35937L4.19797 5.81641L4.79433 5.77995L4.97401 5.62891L5.01568 5.57812L5.1511 4.99609L4.76568 4.53906ZM3.14329 6.82161L2.59772 7.06641L2.48444 7.27214L2.4623 7.33464L2.54303 7.92708L3.06517 8.21615L3.61074 7.97135L3.72402 7.76563L3.74615 7.70313L3.66542 7.11068L3.14329 6.82161Z"
                fill="#919EAB"
              />
            </svg>
          </div>
          <div class="dashboard__sidebar__item__text d-none d-lg-block">
            Active Liens
          </div>
        </router-link>
        <router-link
          class="dashboard__sidebar__item"
          tag="div"
          to="/dashboard/blacklists/pending"
        >
          <div
            class="dashboard__sidebar__item__icon"
            title="Blacklists"
            v-b-tooltip.hover.top
          >
          <svg xmlns="http://www.w3.org/2000/svg" fill="#808080" viewBox="0 0 512 512" width="20" height="20"><path d="M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0zm0 66.8l0 378.1C394 378 431.1 230.1 432 141.4L256 66.8s0 0 0 0z"/></svg>
          </div>
          <div class="dashboard__sidebar__item__text d-none d-lg-block">
            Blacklists
          </div>
        </router-link>
        <div class="dashboard__sidebar__top__section d-none d-lg-block">
          OTHERS
        </div>

        <router-link
          class="dashboard__sidebar__item"
          tag="div"
          to="/dashboard/audittrail?page=1"
        >
          <div
            class="dashboard__sidebar__item__icon"
            title="Audit Trail"
            v-b-tooltip.hover.top
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.9 3.5H8.4V3C8.4 2.20218 9.10137 1.5 10 1.5C10.8986 1.5 11.6 2.20218 11.6 3V3.5H12.1H14.9C15.7986 3.5 16.5 4.2022 16.5 5V17C16.5 17.7978 15.7986 18.5 14.9 18.5H5.1C4.20139 18.5 3.5 17.7978 3.5 17V5C3.5 4.2022 4.20139 3.5 5.1 3.5H7.9ZM8.4 4.33333V3.83333H7.9H5.1C4.45161 3.83333 3.9 4.32446 3.9 5V17C3.9 17.6755 4.4516 18.1667 5.1 18.1667H14.9C15.5484 18.1667 16.1 17.6755 16.1 17V5C16.1 4.32446 15.5484 3.83333 14.9 3.83333H12.1H11.6V4.33333V5C11.6 5.06915 11.5335 5.16667 11.4 5.16667H8.6C8.46647 5.16667 8.4 5.06915 8.4 5V4.33333ZM12.6499 9.55738L12.6499 9.55742L12.6551 9.55238C12.6895 9.51868 12.7411 9.49497 12.8005 9.49329C12.8461 9.49203 12.8894 9.50409 12.9243 9.52543C12.959 9.54664 12.9822 9.57481 12.9948 9.60312C13.0072 9.63108 13.01 9.66034 13.004 9.68825C12.9981 9.71638 12.9826 9.74582 12.9553 9.77111L12.9552 9.77107L12.9501 9.77595L9.45017 13.1092C9.41431 13.1434 9.3607 13.1665 9.3 13.1665C9.2393 13.1665 9.18569 13.1434 9.14983 13.1092L7.74991 11.776L7.74998 11.7759L7.74248 11.769C7.72424 11.7523 7.71113 11.7337 7.70262 11.715C7.69414 11.6963 7.69006 11.6772 7.68986 11.6585C7.68966 11.6399 7.69333 11.6208 7.70134 11.6021C7.70939 11.5833 7.722 11.5646 7.73973 11.5477C7.75751 11.5308 7.78001 11.5161 7.80651 11.5058C7.83304 11.4955 7.86225 11.4901 7.8922 11.4903C7.92216 11.4906 7.95117 11.4966 7.97735 11.5074C8.0035 11.5182 8.02553 11.5332 8.0428 11.5503L8.04272 11.5504L8.05009 11.5574L8.95517 12.4194L9.3 12.7478L9.64483 12.4194L12.6499 9.55738ZM11.2 3C11.2 2.32506 10.6478 1.83333 10 1.83333C9.35224 1.83333 8.8 2.32506 8.8 3C8.8 3.67494 9.35224 4.16667 10 4.16667C10.6478 4.16667 11.2 3.67494 11.2 3Z"
                fill="#919EAB"
                stroke="#919EAB"
              />
            </svg>
          </div>
          <div class="dashboard__sidebar__item__text d-none d-lg-block">
            Audit Trail
          </div>
        </router-link>
        <router-link
          class="dashboard__sidebar__item"
          v-if="isSuperAdmin"
          tag="div"
          to="/dashboard/users?page=1"
        >
          <div
            class="dashboard__sidebar__item__icon"
            title="Admin Users"
            v-b-tooltip.hover.top
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.6364 16.9998V15.4443C13.6364 14.6192 13.3299 13.8278 12.7843 13.2444C12.2388 12.661 11.4988 12.3332 10.7273 12.3332H4.90909C4.13755 12.3332 3.39761 12.661 2.85205 13.2444C2.30649 13.8278 2 14.6192 2 15.4443V16.9998"
                stroke="#919EAB"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.81818 9.22216C9.42483 9.22216 10.7273 7.82928 10.7273 6.11108C10.7273 4.39288 9.42483 3 7.81818 3C6.21153 3 4.90909 4.39288 4.90909 6.11108C4.90909 7.82928 6.21153 9.22216 7.81818 9.22216Z"
                stroke="#919EAB"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M18 17.0001V15.4445C17.9995 14.7552 17.785 14.0856 17.3901 13.5408C16.9952 12.996 16.4423 12.6069 15.8182 12.4346"
                stroke="#919EAB"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.9091 3.10107C13.5348 3.27242 14.0895 3.66161 14.4856 4.2073C14.8816 4.75299 15.0966 5.42414 15.0966 6.11493C15.0966 6.80572 14.8816 7.47687 14.4856 8.02256C14.0895 8.56825 13.5348 8.95744 12.9091 9.12879"
                stroke="#919EAB"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="dashboard__sidebar__item__text d-none d-lg-block">
            Admin Users
          </div>
        </router-link>
      </div>

      <div
        class="dashboard__sidebar__bottom dashboard__sidebar__center"
        style="position: relative"
      >
        <router-link
          class="dashboard__sidebar__item"
          tag="div"
          to="/dashboard/settings/profile"
        >
          <div
            class="dashboard__sidebar__item__icon"
            title="Settings"
            v-b-tooltip.hover.top
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.02777 2C8.94532 2.00004 8.86556 2.02937 8.80272 2.08275C8.73988 2.13613 8.69804 2.21009 8.68467 2.29144L8.34633 4.36277C7.93948 4.48111 7.55153 4.64079 7.1859 4.83967L5.47652 3.61889C5.40959 3.5711 5.3279 3.54857 5.24594 3.55528C5.16398 3.562 5.08704 3.59753 5.02879 3.65557L3.67541 5.00747C3.61758 5.06534 3.58199 5.14174 3.57491 5.22325C3.56783 5.30475 3.5897 5.38615 3.63669 5.45313L4.83924 7.17323C4.63727 7.54096 4.47404 7.93107 4.35278 8.34171L2.29011 8.68478C2.20899 8.69844 2.13535 8.7404 2.08224 8.80321C2.02913 8.86601 1.99999 8.94561 2 9.02785V10.9409C1.99985 11.0227 2.02851 11.1019 2.08094 11.1646C2.13337 11.2273 2.20622 11.2696 2.28671 11.284L4.35074 11.6495C4.47134 12.0594 4.63354 12.4498 4.83584 12.8179L3.61834 14.5211C3.57055 14.588 3.54802 14.6697 3.55473 14.7516C3.56145 14.8336 3.59698 14.9105 3.65503 14.9688L5.00773 16.322C5.06548 16.3798 5.14171 16.4154 5.22307 16.4226C5.30444 16.4298 5.38574 16.4081 5.45274 16.3614L7.17639 15.1549C7.5431 15.355 7.932 15.5158 8.34021 15.6352L8.68467 17.7092C8.69819 17.7905 8.74009 17.8643 8.80291 17.9175C8.86574 17.9708 8.94542 18 9.02777 18H10.941C11.0228 18.0001 11.1021 17.9714 11.1649 17.9188C11.2276 17.8662 11.2698 17.7932 11.2841 17.7126L11.653 15.6304C12.0595 15.5092 12.4466 15.346 12.8114 15.1447L14.5466 16.3621C14.6136 16.4091 14.695 16.4309 14.7765 16.4239C14.858 16.4168 14.9344 16.3812 14.9923 16.3234L16.345 14.9694C16.4033 14.911 16.4389 14.8338 16.4455 14.7515C16.4521 14.6693 16.4292 14.5873 16.381 14.5204L15.1438 12.803C15.3416 12.44 15.501 12.0553 15.6194 11.6515L17.7126 11.2846C17.7932 11.2704 17.8662 11.2282 17.9188 11.1655C17.9714 11.1027 18.0001 11.0234 18 10.9416V9.02853C18 8.94609 17.9706 8.86634 17.9172 8.8035C17.8639 8.74067 17.7899 8.69883 17.7085 8.68546L15.6187 8.34375C15.4995 7.94046 15.3397 7.55643 15.1417 7.19361L16.362 5.45516C16.4089 5.38819 16.4308 5.30679 16.4237 5.22529C16.4166 5.14378 16.3811 5.06738 16.3232 5.00951L14.9699 3.65693C14.9114 3.59864 14.8342 3.56301 14.7519 3.55642C14.6697 3.54982 14.5877 3.57269 14.5208 3.62092L12.808 4.85258C12.4431 4.65211 12.0557 4.48974 11.6482 4.36957L11.2841 2.28804C11.27 2.20731 11.2278 2.13415 11.1651 2.08145C11.1023 2.02875 11.0229 1.99991 10.941 2H9.02777ZM9.32399 2.69565H10.6488L10.9953 4.67323C11.0069 4.73956 11.0374 4.80112 11.0832 4.85044C11.129 4.89976 11.1882 4.93472 11.2535 4.95109C11.7622 5.07785 12.2401 5.2788 12.6762 5.5428C12.7345 5.57813 12.8019 5.59554 12.87 5.59289C12.9381 5.59023 13.004 5.56761 13.0594 5.52785L14.6872 4.35802L15.6241 5.29484L14.4651 6.94633C14.4263 7.00142 14.4045 7.06657 14.402 7.13386C14.3996 7.20114 14.4168 7.26769 14.4515 7.32541C14.7129 7.76051 14.9111 8.23526 15.0378 8.74117C15.0543 8.80706 15.0897 8.86668 15.1397 8.91267C15.1897 8.95867 15.252 8.98903 15.3191 9L17.3043 9.32473V10.6495L15.315 10.9986C15.2486 11.0104 15.1871 11.0412 15.1379 11.0872C15.0886 11.1333 15.0539 11.1927 15.0378 11.2582C14.9126 11.7634 14.7142 12.2382 14.4528 12.6732C14.4177 12.7315 14.4005 12.7988 14.4033 12.8668C14.4061 12.9348 14.4287 13.0005 14.4684 13.0557L15.6438 14.6868L14.7069 15.6243L13.058 14.4674C13.0026 14.4286 12.9372 14.4068 12.8696 14.4046C12.802 14.4025 12.7353 14.42 12.6775 14.4552C12.2436 14.7192 11.7653 14.9211 11.2583 15.0496C11.1933 15.066 11.1344 15.1008 11.0887 15.1498C11.043 15.1989 11.0125 15.2601 11.0008 15.3261L10.6495 17.3043H9.32263L8.99516 15.3349C8.98401 15.2679 8.9535 15.2057 8.90738 15.1558C8.86126 15.1059 8.80155 15.0707 8.73563 15.0543C8.22658 14.9289 7.74662 14.7282 7.30752 14.4647C7.24986 14.4302 7.18345 14.4131 7.11629 14.4155C7.04914 14.4179 6.98411 14.4397 6.92909 14.4783L5.29308 15.6243L4.3555 14.6855L5.51185 13.0693C5.55137 13.0139 5.57378 12.9482 5.57632 12.8802C5.57885 12.8122 5.5614 12.745 5.52611 12.6868C5.25965 12.2466 5.05813 11.7667 4.93096 11.2554C4.91468 11.1903 4.87992 11.1313 4.83086 11.0855C4.78179 11.0397 4.72052 11.0091 4.65444 10.9973L2.69571 10.6495V9.32269L4.65308 8.99728C4.71999 8.98619 4.7822 8.95578 4.83205 8.90979C4.88191 8.8638 4.91723 8.80425 4.93367 8.73845C5.06194 8.22544 5.26336 7.74565 5.52883 7.30639C5.56384 7.24872 5.58132 7.18212 5.57915 7.11469C5.57698 7.04727 5.55525 6.98193 5.5166 6.92663L4.37384 5.29348L5.3121 4.35598L6.93384 5.51495C6.98902 5.55428 7.05448 5.57665 7.12219 5.57931C7.18989 5.58196 7.25691 5.56479 7.31499 5.52989C7.75178 5.26758 8.23285 5.06855 8.74242 4.94361C8.80866 4.92731 8.86864 4.89189 8.91491 4.84176C8.96118 4.79163 8.99168 4.72901 9.00263 4.66168L9.32399 2.69565ZM10 7.21739C8.4672 7.21739 7.21716 8.46733 7.21716 10C7.21716 11.5327 8.4672 12.7826 10 12.7826C11.5328 12.7826 12.7828 11.5327 12.7828 10C12.7828 8.46733 11.5328 7.21739 10 7.21739ZM10 7.91304C11.1568 7.91304 12.0871 8.84329 12.0871 10C12.0871 11.1567 11.1568 12.087 10 12.087C8.84319 12.087 7.91287 11.1567 7.91287 10C7.91287 8.84329 8.84319 7.91304 10 7.91304Z"
                stroke="#919EAB"
                stroke-width="0.5"
              />
            </svg>
          </div>
          <div class="dashboard__sidebar__item__text d-none d-lg-block">
            Settings
          </div>
        </router-link>

        <!-- <div class="dashboard__sidebar__item dashboard__sidebar__item--bordered">
                    <div class="dashboard__sidebar__item__icon">
                        <svg fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.6">
                                <circle cx="16" cy="16" fill="white" r="16" />
                                <path d="M19.4127 13.0564C20.1705 11.227 19.3018 9.12975 17.4724 8.37199C15.643 7.61423 13.5457 8.48296 12.7879 10.3124C12.0302 12.1417 12.8989 14.239 14.7283 14.9968C16.5577 15.7546 18.655 14.8858 19.4127 13.0564Z" fill="#261940" />
                                <path d="M8 23.3279C8 25.5573 24.2007 25.5573 24.2007 23.3279C24.2007 19.5639 20.574 16.5125 16.1003 16.5125C11.6266 16.5125 8 19.5639 8 23.3279Z" fill="#261940" />
                            </g>
                        </svg>
                    </div>
                    <div class="dashboard__sidebar__item__title">{{fullname}}</div>
                </div>-->
        <div @click="logout" class="dashboard__sidebar__item">
          <div
            class="dashboard__sidebar__item__icon"
            title="Log out"
            v-b-tooltip.hover.top
          >
            <svg
              width="16"
              height="18"
              viewBox="0 0 16 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.0167 5.73526H12.0266H12.0266H12.0267H12.0267H12.0268H12.0268H12.0269H12.0269H12.027H12.027H12.0271H12.0271H12.0272H12.0272H12.0273H12.0273H12.0274H12.0274H12.0275H12.0275H12.0276H12.0276H12.0277H12.0277H12.0278H12.0279H12.0279H12.028H12.028H12.0281H12.0281H12.0282H12.0282H12.0283H12.0283H12.0284H12.0284H12.0285H12.0285H12.0286H12.0286H12.0287H12.0287H12.0288H12.0288H12.0289H12.0289H12.029H12.029H12.0291H12.0291H12.0292H12.0293H12.0293H12.0294H12.0294H12.0295H12.0295H12.0296H12.0296H12.0297H12.0297H12.0298H12.0298H12.0299H12.0299H12.03H12.03H12.0301H12.0301H12.0302H12.0302H12.0303H12.0303H12.0304H12.0304H12.0305H12.0305H12.0306H12.0307H12.0307H12.0308H12.0308H12.0309H12.0309H12.031H12.031H12.0311H12.0311H12.0312H12.0312H12.0313H12.0313H12.0314H12.0314H12.0315H12.0315H12.0316H12.0316H12.0317H12.0317H12.0318H12.0318H12.0319H12.0319H12.032H12.0321H12.0321H12.0322H12.0322H12.0323H12.0323H12.0324H12.0324H12.0325H12.0325H12.0326H12.0326H12.0327H12.0327H12.0328H12.0328H12.0329H12.0329H12.033H12.033H12.0331H12.0331H12.0332H12.0332H12.0333H12.0333H12.0334H12.0335H12.0335H12.0336H12.0336H12.0337H12.0337H12.0338H12.0338H12.0339H12.0339H12.034H12.034H12.0341H12.0341H12.0342H12.0342H12.0343H12.0343H12.0344H12.0344H12.0345H12.0345H12.0346H12.0346H12.0347H12.0347H12.0348H12.0349H12.0349H12.035H12.035H12.0351H12.0351H12.0352H12.0352H12.0353H12.0353H12.0354H12.0354H12.0355H12.0355H12.0356H12.0356H12.0357H12.0357H12.0358H12.0358H12.0359H12.0359H12.036H12.036H12.0361H12.0361H12.0362H12.0363H12.0363H12.0364H12.0364H12.0365H12.0365H12.0366H12.0366H12.0367H12.0367H12.0368H12.0368H12.0369H12.0369H12.037H12.037H12.0371H12.0371H12.0372H12.0372H12.0373H12.0373H12.0374H12.0374H12.0375H12.0375H12.0376H12.0377H12.0377H12.0378H12.0378H12.0379H12.0379H12.038H12.038H12.0381H12.0381H12.0382H12.0382H12.0383H12.0383H12.0384H12.0384H12.0385H12.0385H12.0386H12.0386H12.0387H12.0387H12.0388H12.0388H12.0389H12.0389H12.039H12.0391H12.0391H12.0392H12.0392H12.0393H12.0393H12.0394H12.0394H12.0395H12.0395H12.0396H12.0396H12.0397H12.0397H12.0398H12.0398H12.0399H12.0399H12.04H12.04H12.0401H12.0401H12.0402H12.0402H12.0403H12.0403H12.0404H12.0405H12.0405H12.0406H12.0406H12.0407H12.0407H12.0408H12.0408H12.0409H12.0409H12.041H12.041H12.0411H12.0411H12.0412H12.0412H12.0413H12.0413H12.0414H12.0414H12.0415H12.0415H12.0416H12.0416H12.0417H12.0417H12.0418H12.0419H12.0419H12.042H12.042H12.0421H12.0421H12.0422H12.0422H12.0423H12.0423H12.0424H12.0424H12.0425H12.0425H12.0426H12.0426H12.0427H12.0427H12.0428H12.0428H12.0429H12.0429H12.043H12.043H12.0431H12.0431H12.0432H12.0433H12.0433H12.0434H12.0434H12.0435H12.0435H12.0436H12.0436H12.0437H12.0437H12.0438H12.0438H12.0439H12.0439H12.044H12.044H12.0441H12.0441H12.0442H12.0442H12.0443H12.0443H12.0444H12.0444H12.0445H12.0445H12.0446H12.0447H12.0447H12.0448H12.0448H12.0449H12.0449H12.045H12.045H12.0451H12.0451H12.0452H12.0452H12.0453H12.0453H12.0454H12.0454H12.0455H12.0455H12.0456H12.0456H12.0457H12.0457H12.0458H12.0458H12.0459H12.0459H12.046H12.0461H12.0461H12.0462H12.0462H12.0463H12.0463H12.0464H12.0464H12.0465H12.0465H12.0466H12.0466H12.0467H12.0467H12.0468H12.0468H12.0469H12.0469H12.047H12.047H12.0471H12.0471H12.0472H12.0472H12.0473H12.0473H12.0474H12.0475H12.0475H12.0476H12.0476H12.0477H12.0477H12.0478H12.0478H12.0479H12.0479H12.048H12.048H12.0481H12.0481H12.0482H12.0482H12.0483H12.0483H12.0484H12.0484H12.0485H12.0485H12.0486H12.0486H12.0487H12.0487H12.0488H12.0489H12.0489H12.049H12.049H12.0491H12.0491H12.0491H12.0492H12.0492H12.0493H12.0493H12.0494H12.0494H12.0495H12.0495H12.0496H12.0496H12.0497H12.0497H12.0498H12.0498H12.0499H12.0499H12.05H12.05H12.0501H12.0501H12.0502H12.0503H12.0503H12.0504H12.0504H12.0505H12.0505H12.0506H12.0506H12.0507H12.0507H12.0508H12.0508H12.0509H12.0509H12.051H12.051H12.0511H12.0511H12.0512H12.0512H12.0513H12.0513H12.0514H12.0514H12.0515H12.0515H12.0516H12.0517H12.0517H12.0518H12.0518H12.0519H12.0519H12.052H12.052H12.0521H12.0521H12.0522H12.0522H12.0523H12.0523H12.0524H12.0524H12.0525H12.0525H12.0526H12.0526H12.0527H12.0527H12.0528H12.0528H12.0529H12.0529H12.053H12.0531H12.0531V5.83526C12.1394 5.82777 12.2246 5.86398 12.2832 5.93513L12.0167 5.73526ZM12.0167 5.73526L12.007 5.7372C11.8576 5.76704 11.7464 5.88747 11.7085 6.03504L11.7084 6.03529C11.6708 6.18311 11.7084 6.34314 11.8112 6.45202L13.6899 8.58137H5.53985H5.5398H5.53974H5.53969H5.53964H5.53959H5.53954H5.53948H5.53943H5.53938H5.53933H5.53928H5.53923H5.53917H5.53912H5.53907H5.53902H5.53897H5.53891H5.53886H5.53881H5.53876H5.53871H5.53866H5.5386H5.53855H5.5385H5.53845H5.5384H5.53834H5.53829H5.53824H5.53819H5.53814H5.53808H5.53803H5.53798H5.53793H5.53788H5.53783H5.53777H5.53772H5.53767H5.53762H5.53757H5.53751H5.53746H5.53741H5.53736H5.53731H5.53726H5.5372H5.53715H5.5371H5.53705H5.537H5.53694H5.53689H5.53684H5.53679H5.53674H5.53668H5.53663H5.53658H5.53653H5.53648H5.53643H5.53637H5.53632H5.53627H5.53622H5.53617H5.53611H5.53606H5.53601H5.53596H5.53591H5.53586H5.5358H5.53575H5.5357H5.53565H5.5356H5.53554H5.53549H5.53544H5.53539H5.53534H5.53528H5.53523H5.53518H5.53513H5.53508H5.53503H5.53497H5.53492H5.53487H5.53482H5.53477H5.53471H5.53466H5.53461H5.53456H5.53451H5.53446H5.5344H5.53435H5.5343H5.53425H5.5342H5.53414H5.53409H5.53404H5.53399H5.53394H5.53388H5.53383H5.53378H5.53373H5.53368H5.53363H5.53357H5.53352H5.53347H5.53342H5.53337H5.53331H5.53326H5.53321H5.53316H5.53311H5.53306H5.533H5.53295H5.5329H5.53285H5.5328H5.53274H5.53269H5.53264H5.53259H5.53254H5.53248H5.53243H5.53238H5.53233H5.53228H5.53223H5.53217H5.53212H5.53207H5.53202H5.53197H5.53191H5.53186H5.53181H5.53176H5.53171H5.53165H5.5316H5.53155H5.5315H5.53145H5.5314H5.53134H5.53129H5.53124H5.53119H5.53114H5.53108H5.53103H5.53098H5.53093H5.53088H5.53083H5.53077H5.53072H5.53067H5.53062H5.53057H5.53051H5.53046H5.53041H5.53036H5.53031H5.53025H5.5302H5.53015H5.5301H5.53005H5.53H5.52994H5.52989H5.52984H5.52979H5.52974H5.52968H5.52963H5.52958H5.52953H5.52948H5.52943H5.52937H5.52932H5.52927H5.52922H5.52917H5.52911H5.52906H5.52901H5.52896H5.52891H5.52885H5.5288H5.52875H5.5287H5.52865H5.5286H5.52854H5.52849H5.52844H5.52839H5.52834H5.52828H5.52823H5.52818H5.52813H5.52808H5.52803H5.52797H5.52792H5.52787H5.52782H5.52777H5.52771H5.52766H5.52761H5.52756H5.52751H5.52745H5.5274H5.52735H5.5273H5.52725H5.5272H5.52714H5.52709H5.52704H5.52699H5.52694H5.52688H5.52683H5.52678H5.52673H5.52668H5.52663H5.52657H5.52652H5.52647H5.52642H5.52637H5.52631H5.52626H5.52621H5.52616H5.52611H5.52605H5.526H5.52595H5.5259H5.52585H5.5258H5.52574H5.52569H5.52564H5.52559H5.52554H5.52548H5.52543H5.52538H5.52533H5.52528H5.52523H5.52517H5.52512H5.52507H5.52502H5.52497H5.52491H5.52486H5.52481H5.52476H5.52471H5.52465H5.5246H5.52455H5.5245H5.52445H5.5244H5.52434H5.52429H5.52424H5.52419H5.52414H5.52408H5.52403H5.52398H5.52393H5.52388H5.52383H5.52377H5.52372H5.52367H5.52362H5.52357H5.52351H5.52346H5.52341H5.52336H5.52331H5.52325H5.5232H5.52315H5.5231H5.52305H5.523H5.52294H5.52289H5.52284H5.52279H5.52274H5.52268H5.52263H5.52258H5.52253H5.52248H5.52243H5.52237H5.52232H5.52227H5.52222H5.52217H5.52211H5.52206H5.52201H5.52196H5.52191H5.52185H5.5218H5.52175H5.5217H5.52165H5.5216H5.52154H5.52149H5.52144H5.52139H5.52134H5.52128H5.52123H5.52118H5.52113H5.52108H5.52103H5.52097H5.52092H5.52087H5.52082H5.52077H5.52071H5.52066H5.52061H5.52056H5.52051H5.52045H5.5204H5.52035H5.5203H5.52025H5.5202H5.52014H5.52009H5.52004H5.51999H5.51994H5.51988H5.51983H5.51978H5.51973H5.51968H5.51963H5.51957H5.51952H5.51947H5.51942H5.51937H5.51931H5.51926H5.51921H5.51916H5.51911H5.51905H5.519H5.51895H5.5189H5.51885H5.5188H5.51874H5.51869H5.51864H5.51859H5.51854H5.51848H5.51843H5.51838H5.51833H5.51828H5.51823H5.51817H5.51812H5.51807H5.51802H5.51797H5.51791H5.51786H5.51781H5.51776H5.51771H5.51765H5.5176H5.51755H5.5175H5.51745H5.5174H5.51734H5.51729H5.51724H5.51719H5.51714H5.51708H5.51703H5.51698H5.51693H5.51688H5.51683H5.51677H5.51672H5.51667H5.51662H5.51657H5.51651H5.51646H5.51641H5.51636H5.51631H5.51625H5.5162H5.51615H5.5161H5.51605H5.516H5.51594H5.51589H5.51584H5.51579H5.51574H5.51568H5.51563H5.51558H5.51553H5.51548H5.51543H5.51537H5.51532H5.51527H5.51522H5.51517H5.51511H5.51506H5.51501H5.51496H5.51491H5.51485H5.5148H5.51475H5.5147H5.51465H5.5146H5.51454H5.51449H5.51444H5.51439H5.51434H5.51428H5.51423H5.51418H5.51413H5.51408H5.51403H5.51397H5.51392H5.51387H5.51382H5.51377H5.51371H5.51366H5.51361H5.51356H5.51351H5.51345H5.5134H5.51335H5.5133V8.58122L5.50771 8.58153C5.28696 8.5939 5.13381 8.80028 5.14349 9.02031C5.15308 9.23836 5.32051 9.43111 5.54241 9.4205H13.6899L11.8132 11.5476C11.7047 11.6502 11.658 11.8079 11.6885 11.9581L11.6886 11.9583C11.7195 12.1088 11.8267 12.2362 11.9736 12.2746L11.9739 12.2747C12.1225 12.3131 12.2708 12.2512 12.361 12.1297L14.88 9.29708L14.8801 9.29709L14.8816 9.29528L15.0763 9.0656L15.1311 9.00094L15.0763 8.93628L14.8816 8.70659L14.8816 8.70657L14.88 8.7048L12.3591 5.86998L12.0167 5.73526ZM1.21833 0.902571L1.21822 0.901683L1.00004 1.33142H0.900037V1.33208L0.900036 16.6705L0.900039 16.6711C0.90141 16.8953 1.06542 17.0982 1.29129 17.1H1.29207L9.78762 17.1L9.7884 17.1C10.0143 17.0982 10.1783 16.8953 10.1797 16.6711V16.6705V13.4748V13.3748H10.0797H9.49559H9.39559V13.4748V16.2409H1.68411V1.76097H9.39559V4.52705V4.62705H9.49559H10.0797H10.1797V4.52705L10.1797 1.33142L10.1797 1.33081C10.1783 1.10658 10.0143 0.903633 9.7884 0.901875V0.901872H9.78762H1.29754C1.27093 0.899162 1.24507 0.899394 1.21833 0.902571Z"
                fill="#919EAB"
                stroke="#919EAB"
                stroke-width="0.2"
              />
            </svg>
          </div>
          <div class="dashboard__sidebar__item__text d-none d-lg-block logout_btn">
            Log Out
          </div>
        </div>
      </div>

      <div style="position: relative">
        <WovenStrip :loading="false" />
      </div>
    </div>

    <div class="dashboard__content">
      <div class="dashboard__header fixed-header">
        <div class="page">
          <div
            class="page__title title--one"
            :class="pageTitle"
            v-if="!subTitle"
          >
            <div v-if="customMetaOptions && customMetaOptions.title">
              <div
                style="
                  margin-top: -10px;
                  margin-left: -10px;
                  padding-bottom: 6px;
                  cursor: pointer;
                "
                @click="() => $router.go(-1)"
              >
                <svg
                  width="6"
                  height="10"
                  viewBox="0 0 6 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 1L1 5L5 9"
                    stroke="#8191A1"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span
                  style="
                    font-style: normal;
                    font-weight: normal;
                    font-size: 14px;
                    line-height: 16px;
                    color: #8191a1;
                  "
                  >{{ customMetaOptions.page || pageTitle }}</span
                >
              </div>
              <div
                style="
                  font-style: normal;
                  font-weight: normal;
                  font-size: 20px;
                  line-height: 22px;
                "
              >
                {{ customMetaOptions.title }} ::
                <span style="color: #8191a1">{{ customMetaOptions.info }}</span>
              </div>
            </div>
            <div v-else>{{ pageTitle }}</div>
          </div>

          <div class="dashboard__header__menu">
            <div class="dashboard__sidebar__item">
              <div class="toggle" :class="!isLive ? 'toggle-danger' : ''">
                <div class="toggleWrapper" :class="!isLive ? 'test' : 'live'">
                  <input
                    :disabled="disabled"
                    @change="toggle"
                    class="mobileToggle"
                    id="toggle1"
                    name="toggle1"
                    type="checkbox"
                    v-model="isLive"
                  />
                  <label for="toggle1"></label>
                </div>
                <div class="toggle__text">
                  {{ modeText }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <router-view />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import WovenStrip from "@/components/wovenstrip.vue";
import Logo from "@/components/logo";
import EmptyState from "@/components/empty-state.vue";

export default {
  beforeRouteEnter(to, from, next) {
    // if token is avaialble move on
    if (window.localStorage.getItem("gelato")) {
      next();
    }
    // if token is not avaiable redirect to login
    else {
      next({ path: "/login" });
    }
  },
  components: {
    WovenStrip,
    Logo,
    EmptyState,
  },

  created() {
    this.$store.dispatch("fetchBankName");
    this.$store.dispatch("fetchBankList");
  },
  watch: {
    $route(to, from) {
      this.$store.commit("setCustomMetaOptions", null);
      this.changePageTitle(to);
    },
  },
  mounted() {
    this.changePageTitle(this.$route);
    this.$store.commit("setCustomMetaOptions", null);
  },
  computed: {
    customMetaOptions() {
      return this.$store.state.customMetaOptions;
    },
    subTitle() {
      return this.$store.getters.getSubTitle;
    },
    businessName() {
      return this.$store.state.userDetails.business_name;
    },

    fullname() {
      return this.$store.state.userDetails.fullname;
    },

    modeText() {
      if (!this.$store.state.userDetails.is_test) {
        return "Live Mode";
      } else {
        return "Test Mode";
      }
    },

    isSuperAdmin() {
      if (this.$store.state.userRole == "superadmin") {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      isLive: !(this.$store.state.userDetails.is_test ? 1 : 0),
      disabled: false,
      pageTitle: "Dashboard Overview",
      testClass: (this.$store.state.userDetails.is_test
      ? 1
      : 0)
        ? "test"
        : "live",
      toggleSideBar: false,
    };
  },
  methods: {
    changePageTitle(route) {
      const name = route.name.split("-")[0];
      const routeName = {
        mandate: "Direct Debit Mandates",
        view: "PAYOUTS",
        users: "Admin Users",
        audit: "Audit Trail",
        overview: "Dashboard",
        uploadHistory: "Statement Upload History",
        createSingleStatement: "Create Statement Records",
        createBulkStatement: "Create Statement Records",
      };
      this.pageTitle = routeName[name] || name;
    },
    logout() {
      window.localStorage.clear();
      this.$router.push({ name: "login" });
    },

    toggle() {
      // this.testClass = this.isTest ? 'live' : 'test'
      // this.isTest = !this.isTest;

      this.disabled = true;
      let requestObject = {};
      if (this.$store.state.userDetails.is_test) {
        requestObject = {
          is_test: "0",
        };
      } else {
        requestObject = {
          is_test: "1",
        };
      }

      Vue.http
        .put(`dashboard/admin/switch_mode`, requestObject)
        .then((response) => {
          this.disabled = false;
          this.$notify({
            group: "notifications-default",
            type: "success text-white",
            title: "Success",
            text: response.body.message,
          });
          this.$store.dispatch("fetchProfile", { reload: true });
          this.disabled = false;
          this.isLive = response.body.data.is_test == 0 ? true : false;
        })
        .catch((error) => {
          this.isLive = !this.isLive;
          this.disabled = false;
          this.$notify({
            group: "notifications-default",
            type: "error text-white",
            title: "Error",
            text: error.body.message,
          });
        });
    },
  },
};
</script>

<style lang="scss">
.swal-text {
  line-height: 24px;
  text-align: center;
}
</style>
<style lang="scss" scoped>
.show-side-bar {
  width: 230px !important;
  display: block !important;
  transition: 3s;
  .d-none {
    display: block !important;
    &.d-lg-block,
    &.d-xs-block {
      display: block !important;
    }
  }
}

.dashboard__sidebar {
  overflow: hidden;
  height: 100vh;
}

.dashboard__sidebar:hover {
  overflow-y: scroll;
}

.fixed-header {
  position: fixed;
  width: 93%;
  z-index: 100;
}

@media (max-width: 400px) {
  .dashboard__sidebar {
    display: none !important;
    width: 0 !important;
    transition: 3s;
    &.show-side-bar {
      width: 230px !important;
      display: block !important;
      transition: 3s;
    }
  }

  .dashboard__content {
    padding: 0 !important;
  }

  .fixed-header {
    position: fixed;
    width: 100%;
    z-index: 100;
  }
}
.business {
  position: fixed;
  height: 72px;
  padding: 20px;
  left: 0;
  width: 17%;
  z-index: 20;
  top: 0;
  background: #fbfbfb;
}

.dashboard {
  display: flex;
  background: #f8f9fa;
  width: 100% !important;
  max-width: 100vw;
  svg {
    width: 24px;
  }
  // min-width: 1200px;
  &__sidebar {
    width: 17%;
    background-color: #fbfbfb;
    position: relative;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #495255;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @include media(768px) {
      bottom: 0;
      // position: fixed;
    }
    $breakpoint-tablet: 992px;
    @media (max-width: $breakpoint-tablet) {
      width: 80px;
    }
    &__center {
      padding: 0 25px 25px;
    }
    &__top {
      font-size: 14px !important;
      margin-bottom: 34px;
      padding-top: 100px;

      &__header {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        z-index: 100;
        font-family: "Lato", sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 40px;
        color: #000000;
      }
      &__section {
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 14px;

        color: #9a9fa3;
        padding: 20px 0;
      }
    }

    &__item {
      // color: #9a9fa3;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      cursor: pointer;
      text-decoration: none;

      &__icon {
        margin-right: 20px;
      }

      &.router-link-active {
        .dashboard__sidebar__item {
          opacity: 1;
        }
        svg,
        img {
          filter: invert(41%) sepia(49%) saturate(2601%) hue-rotate(318deg)
            brightness(107%) contrast(100%);
        }

        .dashboard__sidebar__item__text {
          /*font-weight: 700;*/
          color: #e00b5b;
        }
      }

      &--bordered {
        padding-top: 16px;
        padding-bottom: 16px;
        border-top: 1px solid rgba(#ffffff, 0.2);
        border-bottom: 1px solid rgba(#ffffff, 0.2);
        .dashboard__sidebar__item__icon {
          margin-right: 15px;
        }
      }
    }

    &__bottom {
      margin-top: -40px;
      min-height: 190px;
      justify-content: flex-end;
      display: flex;
      flex-direction: column;
      border-top: 0.9px solid #ddd;
    }
  }

  &__content {
    height: 100vh;
    overflow: auto;
    flex: 1;
    // width: 83%;
  }
  &__view {
    /*background: #E5E5E5 !important;*/
    margin-top: 80px;
  }
  &__header {
    height: 72px;
    padding: 20px 50px 20px 20px;
    background: #ffffff;

    // position: fixed;
    // width: calc(100% - 220px);

    .page {
      display: flex;
      justify-content: space-between;
    }
    &__menu {
      display: flex;
      justify-content: space-between;
    }
  }
  &__header-clear {
    min-height: 70px;
    padding: 20px 40px;
    width: 100%;
    position: relative;
  }
}

.toggle {
  display: flex;
  align-items: center;
  // background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), #261940;
  border-radius: 100px;
  // padding: 12px 18px;
  &.toggle-danger {
    .toggleWrapper {
      background: #e90c0c !important;
    }
    .toggle__text {
      color: #e90c0c !important;
    }
  }

  .live {
    background: #67d495 !important;
  }

  .toggleWrapper {
    background: red;
    border-radius: 20px;
    padding: 1px;
    height: 20px;
    width: 35px;
  }
  &__text {
    color: #67d495;
    margin-left: 5px;
    font-size: 14px;
  }
  &__display {
    font-size: 12px;
    font-weight: 600;
    margin-right: 8px;
  }
}

.beforeAnimation {
  transition: 0.2s cubic-bezier(0.24, 0, 0.5, 1);
}
.afterAnimation {
  box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 0px 0 hsla(0, 0%, 0%, 0.04),
    0 4px 9px hsla(0, 0%, 0%, 0.13), 0 3px 3px hsla(0, 0%, 0%, 0.05);
  transition: 0.35s cubic-bezier(0.54, 1.6, 0.5, 1);
}

.toggleWrapper input.mobileToggle {
  opacity: 0;
  position: absolute;
}
.toggleWrapper input.mobileToggle + label {
  position: relative;
  display: inline-block;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  transition: 0.4s ease;
  width: 30px;
  height: 15px;
  border-radius: 60px;
}
.toggleWrapper input.mobileToggle + label:before {
  content: "";
  position: absolute;
  display: block;
  transition: 0.2s cubic-bezier(0.24, 0, 0.5, 1);
  height: 18px;
  width: 32px;
  top: 0;
  left: 0;
  border-radius: 30px;
  background-color: rgba(#ffffff, 0.2);
  cursor: pointer;
}
.toggleWrapper input.mobileToggle + label:after {
  content: "";
  position: absolute;
  display: block;
  box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 0px 0 hsla(0, 0%, 0%, 0.04),
    0 4px 9px hsla(0, 0%, 0%, 0.13), 0 3px 3px hsla(0, 0%, 0%, 0.05);
  transition: 0.35s cubic-bezier(0.54, 1.6, 0.5, 1);
  background: #ffffff;
  box-shadow: 0px 2px 2px rgba(45, 45, 45, 0.2);
  height: 18px;
  width: 18px;
  top: -0px;
  left: -2px;
  border-radius: 60px;
  cursor: pointer;
}
.toggleWrapper input.mobileToggle:checked + label:before {
  // background: #67d495;
  transition: width 0.2s cubic-bezier(0, 0, 0, 0.1);
}
.toggleWrapper input.mobileToggle:checked + label:after {
  left: 16px;
}

.title--one {
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 20px;

  color: #000000;
  text-transform: capitalize;
}

@media (min-width: 800px) {
  .fixed-header,
  .dashboard__content {
    width: 90%;
  }
  .dashboard__content {
    // flex: none;
  }
}
@media (min-width: 1000px) {
  .fixed-header,
  .dashboard__content {
    width: 85%;
  }
}
@media (min-width: 1300px) {
  .dashboard__content {
    width: 78%;
  }
}
.vnuban,
.vNUBAN,
.VNUBAN {
  text-transform: none !important;
}
</style>
<style>
.woven-color {
  background: #e00b5b !important;
  border-radius: 4px !important;
}
.small-svg svg {
  height: 20px !important;
  margin: 0;
  margin-left: -20px !important;
}
.logout_btn{
  color: red !important;
}
</style>
